import { APP_INITIALIZER, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { EnAppRoutingModule } from './en-app-routing.module';
import { FrAppRoutingModule } from './fr-app-routing.module';
import { LanguageService } from './core/language.service';

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
    EnAppRoutingModule,
    FrAppRoutingModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (languageService: LanguageService, router: Router) => () => {
        const currentURL = window.location.href;

        // Construct a new object and pass the page href to URLSearchParams
        const searchParams = new URLSearchParams(
          currentURL.substring(currentURL.indexOf('?'))
        );

        const ignoreLoginRouting =
          currentURL.includes('/donor/') ||
          currentURL.includes('/donateur/') ||
          currentURL.includes('/info/') ||
          currentURL.includes('/campaign/') ||
          currentURL.includes('/provider/') ||
          currentURL.includes('id-validate') ||
          currentURL.includes('reset-password') ||
          currentURL.includes('forgot-password') ||
          currentURL.includes('mot-de-passe-oublie') ||
          currentURL.includes('user-registration-feedback') ||
          currentURL.includes('retour-inscription-utilisateur') ||
          searchParams.has('idToken') ||
          searchParams.has('resetToken') ||
          searchParams.has('ssoAccess') ||
          searchParams.has('ssoLoginFailed');

        if(localStorage.getItem('mfaToken')) {
          return;
        }  

        // This code segment is added to set the application login page sub url section to the
        // correct french or english language based on the domain name provided.
        // Also this piece of code should be executed only when the user is not logged in, other wise if the page refreshes
        // or if the user tries to change the language, the user will be navigated to the login page which is incorrect navigation.
        if (!localStorage.getItem('token') && !ignoreLoginRouting) {
          const defaultRoute = languageService.getDefaultRoute(currentURL);
          router.navigate([defaultRoute]);
        }
      },
      deps: [LanguageService, Router],
      multi: true,
    },
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
